window.__machinesReady = true
window.dispatchEvent(new Event('slottrak:machines:ready'))